
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from "../slice/authSlice";
import filterReducer from "../slice/filterSlice";
import commonReducer from '../slice/commonSlice';
import registerReducer from "../slice/registerSlice";

const reducerList = combineReducers({
    auth: authReducer,
    filter: filterReducer,
    common: commonReducer,
    register : registerReducer,
});

const persistConfig = {
    key: 'root',
    storage,
};

const persistedReducer = persistReducer(persistConfig, reducerList);

export const store = configureStore({ reducer: persistedReducer });
export const persistor = persistStore(store);
